var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      style: "" + (_vm.isLoadingData ? "user-select: none; opacity: .75" : ""),
    },
    [
      _c("Header", {
        attrs: {
          defaultOrderFilter: _vm.orderFilter,
          "disabled-filters": _vm.isLoadingData,
          isVisibleCSVButton: _vm.csvAction && _vm.csvAction.isActive,
          isVisibleSearch: !_vm.disableSearch,
        },
        on: {
          csvClick: _vm.startDownloadCsv,
          changePerPage: _vm.handleChangePerPage,
          changeSearchQuery: _vm.handleChangeSearchQuery,
        },
      }),
      _vm._v(" "),
      _c("Content", {
        ref: "contentRef",
        attrs: {
          "table-headers": _vm.tableHeaders,
          rows: _vm.data,
          defaultOrderFilter: _vm.defaultOrderFilter,
          isVisibleOrderByColumn: !_vm.disableOrderByColumn,
          disableSelection: _vm.disableSelection,
          isLoadingData: _vm.isLoadingData,
          disableActions: _vm.disableActions,
          rowKey: _vm.rowKey,
        },
        on: {
          changeOrderFilter: _vm.handleChangeOrderFilter,
          changeSelectedRows: function ($event) {
            _vm.selectedRows = $event
          },
        },
        scopedSlots: _vm._u(
          [
            _vm._l(_vm.contentSlots, function (contentSlot) {
              return {
                key: contentSlot.name,
                fn: function (slotProps) {
                  return [
                    _vm._t(contentSlot.name, null, { row: slotProps.row }),
                  ]
                },
              }
            }),
            {
              key: "actions",
              fn: function (slotProps) {
                return [_vm._t("actions", null, { row: slotProps.row })]
              },
            },
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      !_vm.isLoadingData
        ? _c("Footer", {
            attrs: {
              pagination: _vm.pagination,
              "disabled-pagination": _vm.isLoadingData,
            },
            on: { changePage: _vm.handleChangePage },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }